import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from 'theme';

export const StyledSection = styled.div`
  background-color: ${color('indigo_100')};
  padding: ${spacing('xl5')} ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    padding-top: ${spacing('xl6')};
    padding-bottom: ${spacing('xl6')};
  }
`;

export const StyledContainer = styled.div`
  max-width: ${container('md')};
  margin: auto;
`;

export const StyledHeader = styled.div`
  text-align: center;
  font-size: ${fontSize('lg')};
  margin-bottom: ${spacing('xl4')};
`;

export const StyledSubsection = styled.div`
  padding-top: ${spacing('xl')};
  padding-bottom: ${spacing('xl')};
`;

export const StyledSubsectionHeader = styled.div`
  text-align: center;
  margin-bottom: ${spacing('xl2')};

  p {
    color: ${color('text_subtle_inverse')};
  }
`;

export const StyledSwitcher = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing('lg')};
  margin-bottom: ${spacing('xl2')};
`;
